import { FC } from 'react'

import { Text } from '@ds'
import { GalaxyButton } from '@shared'

import styles from './CollectedStars.module.scss'

type Props = {
  stars: number
}

export const CollectedStars: FC<Props> = ({ stars = 0 }) => {
  return (
    <GalaxyButton className={styles.button}>
      <div className={styles.container}>
        <div className={styles.starsCount}>{stars}</div>
        <Text type="body-4" center>
          total stars collected
        </Text>
      </div>
    </GalaxyButton>
  )
}
